<script>
	import { onMount } from "svelte";

	import Animation from "../../components/AnimationCSS.svelte";
	import Animatable from "../../components/AnimatableCSS.svelte";
	import Spread from "../../newspaper/Spread.svelte";
	import Page from "../../newspaper/Page.svelte";

	export let id;
	export let section;
	export let slideProgress;
	export let content = {};
	export let pages;
	export let animationDuration = 1000;

	let play;
	let reset;
	let played = false;
	let mounted = false;

	onMount(() => {
		mounted = true;
	});

	$: if (mounted && slideProgress === 0 && played) {
		reset();
		played = false;
	}

	$: if (mounted && slideProgress !== 0 && slideProgress !== 1 && !played) {
		play();
		played = true;
	}
</script>

<div class="text">
	<div class="t-heading">{@html content.heading}</div>
	<div class="t-text">{@html content.text}</div>

	<div class="t-fact t-fact--line">
		<div class="t-fact-num">{@html content.fact_num}</div>
		<div class="t-fact-label">{@html content.fact_text}</div>
	</div>
</div>

<div class="animation">
	<Animation duration={animationDuration} bind:play bind:reset>
		{#each pages as page}
			<Animatable left={page.x} top={page.y} anchor={page.anchor || ""} animation={page.animation}>
				{#if page.type === "single"}
					<Page src="{PATH}assets/images/content/{section}_{id}_{page.id}" {...page} />
				{:else}
					<Spread src="{PATH}assets/images/content/{section}_{id}_{page.id}" {...page} />
				{/if}
			</Animatable>
		{/each}
	</Animation>
</div>

<style lang="scss">
	.text {
		width: 100%;
		position: relative;
		z-index: 1;

		@media (min-width: #{$breakpoint-tablet + 1px}) {
			max-width: 436px;
			top: 100px;
		}

		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			max-width: 474px;
			top: 8%;
		}

		@media (max-width: $breakpoint-mobile) {
			top: 40px;
		}
	}

	.t-fact {
		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			max-width: 100%;
		}
	}
</style>
